import delay from 'lodash.delay'
import throttle from 'lodash.throttle'

export const Functions = {
  delay,
  throttle,
}
